export function MealFormSkeleton({ heading }) {
  return (
    <div className="h-full flex flex-col bg-[#fafafa]">
      {/* Header */}
      <div className="flex-shrink-0 bg-white border-b border-gray-200 px-8 py-6">
        <div className="h-5 w-32 bg-gray-200 rounded-lg animate-pulse mb-4" />
        <div className="h-9 w-48 bg-gray-200 rounded-lg animate-pulse" />
      </div>

      {/* Body */}
      <div className="flex-1 overflow-auto p-4 sm:p-8">
        <div className="max-w-3xl space-y-6">
          {/* Tabs */}
          <div className="flex gap-2 border-b border-gray-200 pb-0">
            <div className="h-9 w-24 bg-gray-200 rounded-t-lg animate-pulse" />
            <div className="h-9 w-28 bg-gray-100 rounded-t-lg animate-pulse" />
          </div>

          {/* Meal name */}
          <div className="space-y-2">
            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
            <div className="h-10 w-full bg-gray-200 rounded-lg animate-pulse" />
          </div>

          {/* Category toggles */}
          <div className="space-y-2">
            <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
            <div className="flex gap-2">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="h-8 w-24 bg-gray-200 rounded-full animate-pulse" />
              ))}
            </div>
          </div>

          {/* Tags */}
          <div className="space-y-2">
            <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
            <div className="h-10 w-full bg-gray-200 rounded-lg animate-pulse" />
          </div>

          {/* Duration + Servings */}
          <div className="grid grid-cols-2 gap-6">
            <div className="space-y-2">
              <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
              <div className="h-10 w-full bg-gray-200 rounded-lg animate-pulse" />
            </div>
            <div className="space-y-2">
              <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
              <div className="h-10 w-full bg-gray-200 rounded-lg animate-pulse" />
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex-shrink-0 border-t border-gray-200 bg-white px-4 py-4 sm:px-8 flex gap-3">
        <div className="h-12 w-32 bg-gray-200 rounded-xl animate-pulse" />
        <div className="h-12 w-24 bg-gray-100 rounded-xl animate-pulse" />
      </div>
    </div>
  );
}
